import { Context } from '@nuxt/types/app'
import type { Stripe } from '@stripe/stripe-js'
import { loadStripe } from '@stripe/stripe-js/pure'

declare module 'vue/types/vue' {
  interface Vue {
    $stripe: Stripe | null
  }
}

declare module '@nuxt/types' {
  interface NuxtAppOptions {
    $stripe: Stripe | null
  }
  interface Context {
    $stripe: Stripe | null
  }
}

export default async function (context: Context, inject: (key: string, value: any) => void) {
  let stripe: Stripe | null = null

  try {
    const publishableKey = context.$config?.stripe?.publishableKey as string | undefined

    if (!publishableKey) {
      throw new Error('A Stripe publishable key is required.')
    }

    stripe = await loadStripe(publishableKey, {
      betas: ['custom_checkout_product_catalog_1', 'custom_checkout_tax_id_1']
    })
  } catch (e) {
    context.$sentry?.captureException(e)
  }

  inject('stripe', stripe)
}
